<template>
  <div class="flex items-center justify-between">
    <el-popover
      placement="bottom"
      width="300"
      trigger="manual"
      :content="message.content"
      v-model="message.popover"
    >
      <div slot="reference">
        <slot></slot>
      </div>
    </el-popover>
    <el-popconfirm
      v-if="request"
      title="Are you sure to approve this change?"
      confirmButtonText="Confirm"
      cancelButtonText="Cancel"
      @confirm="approve"
    >
      <a class="alter-request" slot="reference" v-on:click.stop>
        <svg
          :width="size"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            clip-rule="evenodd"
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
          ></path>
        </svg>
      </a>
    </el-popconfirm>
  </div>
</template>
<script>
import api from "@/default/utils/api";
export default {
  name: "AlterRequest",
  mixins: [api],
  props: {
    requester: {
      type: Object,
      required: true,
    },
    size: {
      type: Number,
      default: 16,
    },
  },
  data() {
    return {
      message: {
        popver: false,
        content: "",
      },
    };
  },
  computed: {
    request() {
      return this.hasAlterRequest({
        id: this.requester.id,
        type: this.requester.type,
        attr: this.requester.attr,
      });
    },
  },
  methods: {
    approve() {
      this.$http
        .patch(`/api/v1/alter_requests/${this.request.id}/approve`)
        .then((response) => this.loadAlterRequests())
        .catch((err) => {
          this.$set(this.message, "content", err.response.data.errors);
          this.$set(this.message, "popover", true);
          setTimeout(() => this.$set(this.message, "popover", false), 5000);
        });
    },
  },
};
</script>
<style lang="scss">
a.alter-request {
  @apply text-orange-400 no-underline;
}
</style>
